import { ref, computed } from 'vue';
import { formatDateToPtBR, formatDateForApi } from '@/shared/lib';

export type ValidityDateType = '' | 'todos' | 'especifica';

export function useMasterList() {
  const listType = ref('');
  const status = ref('');
  const prefixType = ref<string[]>([]);
  const format = ref('');
  const validityDateType = ref<ValidityDateType>('');
  const startDate = ref<Date | null>(null);
  const endDate = ref<Date | null>(null);

  const isDateRangePickerOpen = ref(false);

  const isDateRangeValid = computed(() => {
    if (validityDateType.value === '') {
      return false;
    }
    if (validityDateType.value === 'todos') {
      return true;
    }
    return startDate.value !== null && endDate.value !== null;
  });

  const formattedDateRange = computed(() => {
    if (!startDate.value || !endDate.value) {
      return 'Selecionar data';
    }
    return `${formatDateToPtBR(startDate.value)}-${formatDateToPtBR(endDate.value)}`;
  });

  const resetDateRange = () => {
    startDate.value = null;
    endDate.value = null;
  };

  const resetForm = () => {
    listType.value = '';
    status.value = '';
    prefixType.value = [];
    format.value = '';
    validityDateType.value = '';
    resetDateRange();
    isDateRangePickerOpen.value = false;
  };

  const generateList = () => {
    const queryParams = new URLSearchParams({
      type: listType.value,
      status: status.value,
      format: format.value,
      generate: 'true',
    });

    if (validityDateType.value === 'especifica' && startDate.value && endDate.value) {
      queryParams.set('startDate', formatDateForApi(startDate.value) ?? '');
      queryParams.set('endDate', formatDateForApi(endDate.value) ?? '');
    }

    if (listType.value === 'interno' && prefixType.value.length > 0) {
      const normalizedPrefixes = prefixType.value.includes('todos')
        ? ['todos']
        : prefixType.value.filter((p) => p !== 'todos');
      queryParams.set('prefix', normalizedPrefixes.join(','));
    }

    return `/gestao-documentos/lista-mestra?${queryParams.toString()}`;
  };

  return {
    listType,
    status,
    prefixType,
    format,
    validityDateType,
    startDate,
    endDate,
    isDateRangePickerOpen,
    isDateRangeValid,
    formattedDateRange,
    resetDateRange,
    resetForm,
    generateList,
  };
}
